import theme from 'utils/theme'
import { FormattedDate, FormattedNumber, useIntl } from 'react-intl'
import { IndexMetric } from 'utils/types/metricsV2'
import { SkeletonItem } from 'components/Skeletons/Skeletons.styles'
import Tooltip from 'components/Tooltip'
import { color } from 'utils/functions/colors'
import { Cell, TooltipContent } from '../AllMetrics.styles'
import useCumulativeMetric from '../useCumulativeMetric'

interface Props {
  rowData: IndexMetric
}

const PreviousValue = ({ rowData: metric }: Props) => {
  const intl = useIntl()

  const { isCumulativeMetric, isLoadingCumulativeValue, previousValue } =
    useCumulativeMetric({
      metric,
    })

  if (isCumulativeMetric && isLoadingCumulativeValue) {
    return (
      <Cell>
        <SkeletonItem width="5rem" height="1.8rem" />
      </Cell>
    )
  }

  return previousValue ? (
    <Cell>
      <Tooltip
        backgroundColor={color('white')({ theme })}
        boxShadow="0px 0px 15px 0px #1015271a"
        color={color('darkGray')({ theme })}
        id={`metric-previous-value-date-${metric.id}`}
        place="top"
        text={
          <TooltipContent>
            <span>
              {intl.formatMessage({
                id: 'metrics.allMetrics.previousValueDate',
              })}
            </span>
            <FormattedDate
              value={previousValue.date}
              day="numeric"
              month="short"
              year="numeric"
            />
          </TooltipContent>
        }
      >
        <FormattedNumber value={previousValue.value} />
      </Tooltip>
    </Cell>
  ) : (
    <Cell>-</Cell>
  )
}

export default PreviousValue
